import { _$ } from './utils'

;(() => {
  const container = _$('site-navigation')
  if (!container) return

  const button = container.getElementsByTagName('button')[0]
  if (typeof button === 'undefined') return

  const menu = container.getElementsByTagName('ul')[0]
  if (typeof menu === 'undefined') return

  let navToggled = false

  const toggleNavigation = (navToggled) => {
    button.setAttribute('aria-expanded', navToggled ? 'true' : 'false')
    menu.setAttribute('aria-hidden', navToggled ? 'false' : 'true')

    container.classList[navToggled ? 'add' : 'remove']('toggled')

    handleNavToggle(menu, navToggled)
  }

  button.onclick = () => {
    navToggled = !navToggled

    toggleNavigation(navToggled)
  }

  // click away
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-navigation') && navToggled) {
      navToggled = !navToggled
      toggleNavigation(false)
    }
  })

  // ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && navToggled) {
      navToggled = !navToggled
      toggleNavigation(false)
    }
  })

  const handleNavToggle = (nav, navToggled) => {
    // Apply overflow hidden to document body if it's a small screen
    if (window.innerWidth < 768) {
      document.body.style.overflow = navToggled ? 'hidden' : ''
    }
    // Toggle "aria-hidden" and "style.display" attributes on nav menu (ul).
    nav.setAttribute('aria-hidden', navToggled ? 'false' : 'true')
    nav.style.display = navToggled ? 'block' : 'none'

    // Enable scrolling if menu is longer than the screen
    const wrapper = menu.parentElement
    if (wrapper.offsetHeight < nav.offsetHeight + 64) {
      nav.classList.add('overflow-y-scroll')
      nav.style.height = `calc(${wrapper.offsetHeight}px - 6rem)`
    }
  }
})()
